import { Menu, type MenuProps } from 'antd';
import { useContext, useLayoutEffect, useRef, useState } from 'react';
import { FlatDetailContext } from '../detail-surface';

/** Keep navigation in step with the detail container, including nested dialogs. */
export function DetailNavigation(props: Omit<MenuProps, 'mode'>) {
  const inDialog = useContext(FlatDetailContext);
  const host = useRef<HTMLDivElement>(null);
  const [compact, setCompact] = useState(false);

  useLayoutEffect(() => {
    const container = inDialog
      ? host.current?.closest('.ant-modal-container')
      : host.current?.ownerDocument.documentElement;
    if (!container) return;

    const update = () => {
      const width = container.getBoundingClientRect().width;
      // 1120 与各详情页 @media/@container 断点严格一致：布局只在 ≤1120 时把
      // 导航换成整行块，JS 提前（如 1280）切 horizontal 会让菜单留在 190px
      // 列格里被 antd 折叠成 "…" 溢出菜单。
      if (width > 0) setCompact(width <= 1120);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(container);
    return () => observer.disconnect();
  }, [inDialog]);

  return (
    <div ref={host} data-crm-navigation style={{ minWidth: 0 }}>
      <Menu {...props} mode={compact ? 'horizontal' : 'inline'} />
    </div>
  );
}
